import "./Fire.css";

function MediumFire() {
  return (
    <div className="content">
      <div className="light"></div>
      <div className="fire">
        <div className="medium"></div>
        <div className="front"></div>
      </div>
      <div className="wood">
        <div className="stick"></div>
        <div className="stick"></div>
        <div className="stick"></div>
      </div>
    </div>
  );
}

export default MediumFire;
